<template>
  <div class="container-fluid">
    <el-form
      style="margin-top: 10px"
      size="medium"
      :inline="true"
      :model="search"
    >
      <el-form-item>
        <el-date-picker
          style="width: 250px; margin-left: 25px"
          v-model="search.start_end"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="daterange"
          start-placeholder="start time"
          end-placeholder="end time"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select v-model="search.deal_type" placeholder="Please select">
          <el-option label="Processed" :value="0"></el-option>
          <el-option label="Pending" :value="1"></el-option>
          <el-option label="Ignore" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="search.warn_type" placeholder="Please select">
          <el-option label="Warn type1" :value="1"></el-option>
          <el-option label="Warn type2" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="tosearch()">search</el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 6px;">
      <div align="left">
        <b>{{ total }}</b> Warning
      </div>
      <el-table v-tb-height="{ bottom: 40, self: this }"  max-height="600" stripe border :data="list" empty-text="Temporarily no data" >
        <el-table-column prop="warn_name" label="Warn Name" min-width="80px"></el-table-column>
        <el-table-column prop="describes" label="Describe" min-width="200px"></el-table-column>
        <el-table-column prop="warn_time" label="Warning Time" min-width="100px"></el-table-column>
        <el-table-column prop="device_id" label="Device Id" min-width="80px">
          <template slot-scope="scope">
            {{ scope.row.device_id ? scope.row.device_id.substring(7) : "" }}
          </template>
        </el-table-column>
        <el-table-column v-if="show_type==1" prop="crafite_uuid" label="Crafite Id" min-width="80px">
          <template slot-scope="scope">
            {{ scope.row.crafite_uuid.substring(2) }}
          </template>
        </el-table-column>
        <el-table-column v-if="show_type==1" prop="" label="Bound device" min-width="110px">
          <template slot-scope="scope">
            <template>
              <div>ID: {{ scope.row.bind_device ? scope.row.bind_device.substring(7) : "" }}</div>
              <div>Time: {{ scope.row.bind_time  }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column v-if="is_deal==0" prop="deal_des" label="Treatment method" min-width="100px"></el-table-column>
        <el-table-column v-if="is_deal==0" prop="deal_time" label="Treatment time" min-width="100px">
          <template slot-scope="scope">
            {{new Date(scope.row.deal_time*1000)}}
          </template>
        </el-table-column>
        <el-table-column v-if="is_deal!=0" prop="" label="operator" min-width="120px">
          <template slot-scope="scope">
            <a v-if="scope.row.deal_status==1&&is_deal!=0" @click="toIgnore(scope.row)"><i
              style="color: #FF9912;"
              class="el-icon-s-order content"></i>Ignore</a>
            <a v-if="is_deal!=0" v-on:click="showHandle(scope.row)"><i class="el-icon-s-data update"></i>Handle</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div align="right">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="Handle Warn"
      :visible.sync="handleVisible"
      @close="closeHandle()"
      destroy-on-close
      top="20vh"
      width="450px"
    >
      <WarnUpate v-if="handleVisible" :chooseItem="chooseItem" @closeAdd="closeHandle()"></WarnUpate>
    </el-dialog>
  </div>
</template>

<script>
import WarnUpate from './WarnUpdate'
export default {
  name: "WarnManage",
  components: {WarnUpate},
  data() {
    return {
      height: 0,
      show_type:1,
      is_deal:1,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      handleVisible:false,
      search: {
        deal_type: 1,
        warn_type: 1,
        start: this.getNextDate(-7) + " 00:00:00",
        end: this.getNextDate(0) + " 23:59:59",
        start_end: [
          this.getNextDate(-7) + " 00:00:00",
          this.getNextDate(0) + " 23:59:59",
        ],
        page: 1,
        size: 20,
      },
    };
  },
  created() {
    this.getData();
  },
  mounted() {},
  methods: {
    getNextDate: function (day) {
      var dd = new Date();
      dd.setDate(dd.getDate() + day);
      var y = dd.getFullYear();
      var m =
        dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
      var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
      return y + "-" + m + "-" + d;
    },
    getData() {
      this.$api.rootV1.post("/web/warning/getWarnList", this.search, (res) => {
        this.list = res.data;
        this.total = res.totalCount * 1;
      });
    },
    tosearch() {
      if (this.search.start_end) {
        this.search.start = this.search.start_end["0"];
        this.search.end = this.search.start_end["1"];
      } else {
        this.search.start = this.getNextDate(-7) + " 00:00:00";
        this.search.end = this.getNextDate(0) + " 23:59:59";
      }
      this.search.page=1;
      this.is_deal=this.search.deal_type
      this.show_type=this.search.warn_type
      this.getData();
    },
    toIgnore(row){
      this.$api.rootV1.post(
        "/web/warning/deal",
        {warn_id:row.warn_id,deal_type:2},
        (res) => {
            this.getData();
            this.$message.success('Successfully Ignored!')
        },
        (res) => {
            this.$message.success('operation failed!')
        }
      );
    },
    showHandle (row) {
      this.handleVisible=true
      this.chooseItem=row
    },
    closeHandle(){
      this.handleVisible=false
      this.getData()
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getData();
    }
  }
};
</script>

<style scoped>
.style1 {
  width: 15px;
  height: 15px;
  display: flex;
  float: left;
  margin-left: 5px;
  margin-top: auto;
  margin-bottom: auto;
}
.block{
  position: absolute;
  right: 15px;
  bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/main/warning/WarnManage.vue